<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-request-table
            :data="data"
            @back="back"
            @loadMore="loadMore"
            @search="search"
            @refresh="getData"
            :title="'REPSE'"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
    
  <script>
import RepseRequestTable from './components/RepseRequestTable.vue'
import vendor from '@/http/requests/vendor/index.js'
export default {
  components: {
    RepseRequestTable,
  },
  data() {
    return {
      data: [],
      item: {},
      lastPage: 1,
      loadingPage: 'repse-requests-loading',
      params: {
        rfc:'',
        search: '',
        page: 1,
      },
    }
  },  
  methods: {
    back(){
      this.$router.push('/expenses')
    },
    getData () {
      this.$vs.loading()
      const payload = {...this.params}
      vendor
        .getRepseRequests(payload)
        .then((response) => {
          this.lastPage = response.data.last_page
          this.data = response.data.current_page === 1
        ? [...response.data.data]
        : [...this.data, ...response.data.data]

          this.$vs.loading.close()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          console.log(response)
           this.$vs.loading.close()
        })
    },
    loadMore () {
      console.log('more')
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      console.log('more',this.params.page)
      this.getData()
    },
    search (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    init () {
      const storageVendor = localStorage.getItem('vendor')
      let vendorActive = JSON.parse(storageVendor)
      let repseActive = vendorActive.repse_active

      if(repseActive == 1){
        this.getData()
      }else{
        this.$router.push('/pages/not-authorized')
      }
    }

  },
  mounted () {
    const storageVendor = localStorage.getItem('vendor')
    let vendor = JSON.parse(storageVendor)
    this.params.rfc = vendor.rfc
    this.init()
  },
  watch: {
    isLoading (val) {
      if (val) {
        this.$vs.loading()
      } else {
         this.$vs.loading.close()
      }
    },
  },
}
</script>
    
    <style>
</style>s